import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Room {
  constructor (params = {}) {
    const {
      id,
      externalIds,
      sequence,
      name,
      type,
      typeId,
      facility,
      facilityId
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.sequence = sequence || null
    this.name = name || null
    this.typeId = typeId || null
    this.type = type || this.typeId
    this.facilityId = facilityId || null
    this.facility = facility || this.facilityId
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      name: item.name,
      facilityId: item.facilityId,
      typeId: item.typeId
    }
  }
}